
export const nav = {
  home: 'Início',
  assessment: 'Avaliação',
  results: 'Resultados',
  pricing: 'Preços',
  signIn: 'Entrar',
  signOut: 'Sair',
  dashboard: 'Painel',
  admin: 'Admin',
  support: 'Suporte',
  recruitment: 'Recrutamento',
  orgChart: 'Organograma',
  comparison: 'Otimização de Talentos',
  positions: 'Posições',
  profiles: 'Perfis',
  forms: 'Formulários',
  funnel: 'Funil',
  team: 'Equipe'
};
